import qs from 'qs';

const baseURL = '/transactions';
const invoiceURL = '/invoices';

const getData = R.prop('data');

function query() {
    return axios.get(baseURL).then(getData);
}

function getInvoices({ params }) {
    const {
        start = '',
        end = '',
        campaign_ids = [],
        payment_method = 'STRIPE',
        sort_by = [],
        include_invoice_header = false,
        page = 1,
        invoice_identity = '',
        userAccountId = '',
    } = params;
    return axios
        .get(invoiceURL, {
            params: {
                start: start || undefined,
                end: end || undefined,
                campaign_ids: campaign_ids[0] ? campaign_ids : undefined,
                payment_method: payment_method || undefined,
                sort_by: sort_by[0] ? sort_by : undefined,
                include_invoice_header,
                page,
                page_size: 10,
                invoice_identity: invoice_identity || undefined,
                userAccountId: userAccountId || undefined,
            },
            paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: 'indices' }),
        })
        .then(getData);
}

function getInvoiceDownlaod(id) {
    return axios.get(`${invoiceURL}/${id}/excel`).then(getData);
}

function getCampaignForInvoice({ userAccountId }) {
    return axios
        .get(`${invoiceURL}/campaigns`, {
            params: { userAccountId: userAccountId || undefined },
        })
        .then(getData);
}

function tryToPayInvoice({ invoiceId, paymentMethod, cardId }) {
    return axios.post(`${invoiceURL}/${invoiceId}/try_to_pay`, {
        paymentMethod,
        cardId,
    });
}

export default {
    query,
    getInvoices,
    getInvoiceDownlaod,
    getCampaignForInvoice,
    tryToPayInvoice,
};
